import React, { useEffect, useState, useRef } from 'react'; //import React Component
import { NavLink } from 'react-router-dom';
import { cloudStore } from '../firebase';
import { collection, query, where, updateDoc, doc, getDocs, increment, setDoc } from 'firebase/firestore';

export function AllMadeCard() {
    const [click, setclick] = useState(0)
    const topFunction = () => {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    };
    const [createCollection, setcreateCollection] = useState([])
    // Show create
    useEffect(() => {
        getDocs(query(collection(cloudStore, "productData"), where("Product_Information", "!=", null)))
            .then((querySnapshot) => {
                const data = querySnapshot.docs.map((doc) => doc.data());
                setcreateCollection(data)
            })
        createCollection.sort((a, b) => b["Product_Information"]["date"] - a["Product_Information"]["date"]);
    }, [click]);

    const makefire = async (e) => {
        let clickvalue = click
        setclick(clickvalue + 1)
        let value = e.target.dataset.value
        const proExist = await getDocs(query(collection(cloudStore, "productData"), where("Product_Information.proname", "==", value)));
        const proData = proExist.docs.map(doc => doc.data());

        let docData = {}
        if (proData[0].OnFire) {
            docData = {
                OnFire: false
            }
        } else {
            docData = {
                OnFire: true
            }
        }
        updateDoc(doc(cloudStore, "productData", proData[0].Product_Information.proID), docData)
    }

    const makeoffLine = async (e) => {
        let clickvalue = click
        setclick(clickvalue + 1)
        let value = e.target.dataset.value
        const proExist = await getDocs(query(collection(cloudStore, "productData"), where("Product_Information.proname", "==", value)));
        const proData = proExist.docs.map(doc => doc.data());
        let docData = {}
        if (proData.length > 0) {
            if (proData[0].offShelves) {
                docData = {
                    offShelves: false
                }
            } else {
                docData = {
                    offShelves: true
                }
            }
            updateDoc(doc(cloudStore, "productData", proData[0].Product_Information.proID), docData)
        }
    }

    //Delete comment
    // const deleteComment = async (e) => {
    //     const value = e.target.dataset.value;
    //     await deleteDoc(doc(cloudStore, "productData", value));
    // }

    const [ifaddstock, setifaddstock] = useState(false)
    const [proID, setproID] = useState("")
    const changeStock = (e) => {
        let value = e.target.dataset.value
        setproID(value)
        if (ifaddstock) {
            setifaddstock(false)
        } else {
            setifaddstock(true)
        }
    }

    const [inOrde, setinOrde] = useState("增加库存")
    const handleInputChange = (e) => {
        let { value } = e.target
        setinOrde(value)
    }

    const [whattodo, setwhattodo] = useState("线下销售")
    const handleInputChange2 = (e) => {
        let { value } = e.target
        setwhattodo(value)
    }

    const [howchange, sethowchange] = useState(0)
    const handleInputChange3 = (e) => {
        let { value } = e.target
        sethowchange(value)
    }


    let userID = localStorage.getItem("currentLoginUserID");
    const changestocknum = async () => {
        let button = document.querySelector(".submit");
        var newDiv = document.createElement("div");
        var text = "";
        newDiv.classList.add("tips");
        setTimeout(() => { newDiv.classList.add("disappear") }, 4500);
        const proExist = await getDocs(query(collection(cloudStore, "productData"), where("Product_Information.proID", "==", proID)));
        const proData = proExist.docs.map(doc => doc.data());

        let consumptionID = getRandomInt(1000, 9999) + userID + proID;
        if (howchange.length > 0) {
            if (proData.length > 0) {
                if (inOrde === "增加库存") {
                    const docData = {
                        "LeftNum": increment(howchange),
                    }
                    updateDoc(doc(cloudStore, "productData", proID), docData).then(() => {
                        var newDiv2 = document.createElement("div");
                        var text = document.createTextNode("已提交");
                        newDiv2.classList.add("tips");
                        newDiv2.appendChild(text);
                        newDiv2.style.color = "red"
                        button.after(newDiv2);
                        setTimeout(() => { window.location.reload() }, 500);
                    })
                } else {
                    if (whattodo === "线下销售") {
                        const docData = {
                            "LeftNum": increment(-howchange),
                            "Earn": increment(+howchange * proData[0].Product_Information.proprice),
                            "SellNum": increment(+howchange),
                            "SellPeople": increment(+1)
                        }
                        updateDoc(doc(cloudStore, "productData", proID), docData).then(() => {
                            var newDiv2 = document.createElement("div");
                            var text = document.createTextNode("已提交");
                            newDiv2.classList.add("tips");
                            newDiv2.appendChild(text);
                            newDiv2.style.color = "red"
                            button.after(newDiv2);
                            setTimeout(() => { window.location.reload() }, 500);
                        })
                    } else {
                        const docData = {
                            "LeftNum": increment(-howchange),
                        }
                        updateDoc(doc(cloudStore, "productData", proID), docData)
                        const docData2 = {
                            user: userID,
                            useWhat: proID,
                            howmany: howchange,
                            consumptionID: consumptionID
                        }
                        setDoc(doc(cloudStore, "employeeConsumption", consumptionID), docData2).then(() => {
                            var newDiv2 = document.createElement("div");
                            var text = document.createTextNode("已提交");
                            newDiv2.classList.add("tips");
                            newDiv2.appendChild(text);
                            newDiv2.style.color = "red"
                            button.after(newDiv2);
                            setTimeout(() => { window.location.reload() }, 500);
                        })
                    }
                }
            }
        } else {
            text = document.createTextNode("请输入全部信息.");
            newDiv.appendChild(text);
            button.after(newDiv);
        }
    }

    let eachCollection = null
    if (createCollection && Array.isArray(createCollection)) {
        createCollection.sort((a, b) => b["Product_Information"]["proname"].localeCompare(a["Product_Information"]["proname"], 'zh-Hans-CN'));
        createCollection.sort((a, b) => {
            if (a["offShelves"] !== true) {
                return -1;
            } else if (b["offShelves"] !== true) {
                return 1;
            } else {
                return 0;
            }
        });
        eachCollection = createCollection.map((content) => {
            let pic = content["Product_Information"]["pic"]
            let proname = content["Product_Information"]["proname"]
            let proID = content["Product_Information"]["proID"]
            let author = content["Product_Information"]["author"]
            let ifOnFire = content["OnFire"]
            let ifoffShelves = content["offShelves"]
            let firebutton = "nothing"
            let offShelvesbutton = "nothing"

            if (ifOnFire) {
                firebutton = "profile_explore2"
            }

            if (ifoffShelves) {
                offShelvesbutton = "profile_explore2"
            }

            return (
                <div className="each" key={proname}>
                    <div className="each_pic">
                        <img
                            draggable={false}
                            src={pic}
                            alt={proname}
                            key={proname}
                        />
                    </div>
                    <div key={proname}>{proname}</div>
                    <div>
                        <NavLink to={"/Food/" + proname}><div
                            className="button profile_explore"
                            onClick={topFunction}
                        >
                            Explore
                        </div>
                        </NavLink>
                        <NavLink to={"/revise/" + proname + ":&:" + author}><div
                            className="button profile_explore"
                            onClick={topFunction}
                        >
                            Revise
                        </div></NavLink>
                        <div className={"button profile_explore " + offShelvesbutton} data-value={proname} onClick={(e) => makeoffLine(e)}>
                            下架
                        </div>
                        <div
                            className={"button profile_explore " + firebutton}
                            data-value={proname}
                            onClick={(e) => makefire(e)}>
                            搞火
                        </div>
                        <div
                            className={"button profile_explore"}
                            data-value={proID}
                            onClick={(e) => changeStock(e)}>
                            滥用特权
                        </div>
                        {/* <div
                            style={{ color: "red" }}
                            className="button profile_explore"
                            onClick={(e) => deleteComment(e)}
                            data-value={proID}>
                            删除
                        </div> */}
                    </div>
                </div >
            )
        })
    }

    return (
        <div className='collection_content'>
            <div className='h2bg'>
                <h2>Create Product Post</h2>
            </div>
            <div className="store">
                {eachCollection}
            </div>
            {ifaddstock === true ?
                <>
                    <div>
                        <div className='forCloseFullSreen' onClick={changeStock}></div>
                        <div className='fillCoupon'>
                            <form>
                                <div className='fillContent'>
                                    <div >
                                        <h3>对库存的操作</h3>
                                        <div style={{ width: "20%", margin: "auto" }}>
                                            <label className="container" >增加库存
                                                <input
                                                    type="radio"
                                                    name="operation"
                                                    value="增加库存"
                                                    onChange={(e) => handleInputChange(e)}
                                                    checked={inOrde === "增加库存"} />
                                                <span className="checkmark"></span>
                                            </label>
                                            <label className="container">降低库存
                                                <input
                                                    type="radio"
                                                    name="operation"
                                                    value="降低库存"
                                                    onChange={(e) => handleInputChange(e)}
                                                    checked={inOrde === "降低库存"} />
                                                <span className="checkmark"></span>
                                            </label>
                                        </div>
                                    </div>
                                    {inOrde === "降低库存" ?
                                        <>
                                            <div>
                                                <div style={{ width: "20%", margin: "auto" }}>
                                                    <label className="container">线下销售
                                                        <input
                                                            type="radio"
                                                            name="reason"
                                                            value="线下销售"
                                                            onChange={(e) => handleInputChange2(e)}
                                                            checked={whattodo === "线下销售"} />
                                                        <span className="checkmark"></span>
                                                    </label>
                                                    <label className="container">个人使用
                                                        <input
                                                            type="radio"
                                                            name="reason"
                                                            value="个人使用"
                                                            onChange={(e) => handleInputChange2(e)}
                                                            checked={whattodo === "个人使用"} />
                                                        <span className="checkmark"></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </> : null
                                    }
                                    <div>
                                        {inOrde === "增加库存" ?
                                            <>

                                                <label htmlFor="giveout" style={{ fontSize: "25px" }}>增加库存值: </label>
                                            </> :
                                            <label htmlFor="giveout" style={{ fontSize: "25px" }}>减少库存值: </label>

                                        }
                                        <input
                                            type="number"
                                            placeholder="输入数值"
                                            onChange={(e) => { handleInputChange3(e) }}
                                            value={howchange}
                                        />
                                    </div>
                                    <div className="button submit" style={{ margin: "0px auto 40px auto" }} onClick={changestocknum}>Submit</div>
                                </div>
                            </form>
                        </div>
                    </div>
                </> : null
            }
        </div >
    );
}

function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min) + min);
} 